import React, { useState, useEffect } from "react";
import SwaggerUI from "swagger-ui-react";
import "swagger-ui-react/swagger-ui.css";
import "../pages/apiDocs.css";

export default function APIDocs() {
  const [apiDocs, setApiDocs] = useState(null);
  const [error, setError] = useState(null);
  const [activeTab, setActiveTab] = useState("introduction");

  useEffect(() => {
    fetch("https://meine-fastapi-api-b6fyhsg2dcejcab9.westeurope-01.azurewebsites.net/openapi.json")
      .then((response) => {
        if (!response.ok) {
          throw new Error("Fehler beim Laden der API-Dokumentation");
        }
        return response.json();
      })
      .then((data) => setApiDocs(data))
      .catch((err) => setError(err.message));
  }, []);

  return (
    <div className="api-docs-container">
      <h1 className="title">📖 API-Dokumentation</h1>
      <p className="api-description">
        Hier finden Sie alle Informationen zur Nutzung unserer Produktinformations-API.
      </p>
      
      {error && <p className="error">{error}</p>}
      {!apiDocs && !error && <p className="loading">⏳ Lade API-Dokumentation...</p>}
      
      {/* Tab Navigation */}
      <div className="tab-container">
        {["introduction", "endpoints", "try-it-out"].map((tab) => (
          <button
            key={tab}
            className={`tab ${activeTab === tab ? "active" : ""}`}
            onClick={() => setActiveTab(tab)}
          >
            {tab === "introduction" ? "📌 Einführung" : 
             tab === "endpoints" ? "🔗 Endpunkte" : 
             "🚀 Testen"}
          </button>
        ))}
      </div>

      {/* Introduction Tab */}
      {activeTab === "introduction" && (
        <div className="introduction-section">
          <h2>👋 Willkommen zur Produktinformations-API</h2>
          <p>
            Nutzen Sie unsere API, um detaillierte Produktinformationen, Herstellerangaben und Zutatenlisten anhand eines Produktnamens oder Barcodes zu erhalten.
          </p>
          
          <h3>🔐 Authentifizierung</h3>
          <p>
            Ein **Zugriffstoken** wird benötigt. Fordern Sie Ihren persönlichen Token über unser <a href="/kontakt">Kontaktformular</a> an.
          </p>

          <h3>🔎 Hauptendpunkte</h3>
          <ul>
            <li>📌 <strong>Produktsuche nach Name</strong></li>
            <li>📌 <strong>Produktsuche nach Barcode</strong></li>
          </ul>

          <h3>📜 Antwortformat</h3>
          <pre>
            {`{
  "product": {
    "name": "Coca Cola Kasten 12 x 1 l PET ",
    "manufacturer": "Coca Cola Erfrischungsgetränke AG",
    "production_date": "2025-02-25",
    "ingredients": "Wasser, Zucker, Orangensaft aus Orangensaftkonzentrat, Kohlensäure, Säuerungsmittel Citronensäure, Citrusextrakt, natürliches Orangenaroma mit anderen natürlichen Aromen, Antioxidationsmittel Ascorbinsäure, Farbstoff Carotin, Stabilisatoren (E 412, E 414 und E 445)",
    "barcode": "5449000017963"
  }
}`}
          </pre>
        </div>
      )}

      {/* Endpoints Tab */}
      {activeTab === "endpoints" && (
        <div className="endpoints-container">
          {apiDocs && Object.entries(apiDocs.paths).map(([path, methods]) => (
            <div key={path} className="endpoint-card">
              <h3 className="endpoint-title">🔗 {path}</h3>
              {Object.entries(methods).map(([method, details]) => (
                <div key={method} className="method-card">
                  <span className={`method ${method.toUpperCase()}`}>{method.toUpperCase()}</span>
                  <p className="description">{details.summary || "Keine Beschreibung verfügbar."}</p>
                </div>
              ))}
            </div>
          ))}
        </div>
      )}

      {/* Try It Out (Swagger UI) */}
      {activeTab === "try-it-out" && (
        <div className="swagger-ui-container">
          <SwaggerUI url="https://meine-fastapi-api-b6fyhsg2dcejcab9.westeurope-01.azurewebsites.net/openapi.json" />
        </div>
      )}
    </div>
  );
}
